var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"offer-deal-prices",class:[
    {
      'offer-deal-prices--columns': _vm.$mqUtils.isMobile
    }
  ]},[_c('span',{staticClass:"offer-deal-prices__item offer-deal-prices__item--final"},[_vm._v("\n    CHF "+_vm._s(_vm._f("formatPrice")(_vm.finalPrice))),_c('span',[_vm._v("/"+_vm._s(_vm.$t('offerCard.mth')))])]),_vm._v(" "),(_vm.finalPrice !== _vm.regularPrice)?_c('span',{staticClass:"offer-deal-prices__item offer-deal-prices__item--regular"},[_vm._v("\n    CHF "+_vm._s(_vm._f("formatPrice")(_vm.regularPrice))+"/"+_vm._s(_vm.$t('offerCard.mth'))+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }